var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table-pagination',{attrs:{"headers":_vm.headers,"prop-filter":{
      'ad_id': _vm.adId
    },"map-keys":_vm.dataTablePaginationData.mapKeys,"translation":_vm.translation,"api-read":_vm.dataTablePaginationData.apiRead,"disable-cus-template":['coins']}})
}
var staticRenderFns = []

export { render, staticRenderFns }